<div class="modal-header">
  <h5 class="modal-title">Aviso de Segurança</h5>
</div>
<div class="modal-body">
  <div *ngIf="loginExpireSeconds > 0">
  <p>A sua sessão de trabalho está prestes a expirar.</p>
  <div class="progress progress-xs my-3" style="height:26px;">
    <div class="progress-bar bg-danger progress-bar-striped progress-bar-animated" role="progressbar" [style.width]="loginExpirePercentage+'%'"
    [attr.aria-valuenow]="loginExpirePercentage" aria-valuemin="0" aria-valuemax="100">{{loginExpireSeconds}}</div>
  </div>
  <p>Selecione uma das opções</p>
  </div>

  <div *ngIf="loginExpireSeconds <= 0">
      <form novalidate>
        <p class="text-muted">Sign In to your account</p>
        <div class="input-group mb-3">
          <span class="input-group-addon">
            <i class="icon-user"></i>
          </span>
          <input type="text" readonly class="form-control" placeholder="Username" name="username" [ngModel]="username">
        </div>
        <div class="input-group mb-4">
          <span class="input-group-addon">
            <i class="icon-lock"></i>
          </span>
          <input type="password" class="form-control" placeholder="Password" name="password" autofocus tabindex="2" [(ngModel)]="password">
        </div>
        <div class="row">
          <div class="col-12 error" style="padding-top: 10px;">
            {{errorMessage}}
          </div>
        </div>
      
      </form>
  </div>

</div>
<div class="modal-footer">
  <button type="submit" class="btn btn-primary btn-sm" *ngIf="loginExpireSeconds <= 0" tabindex="3" [ladda]='isSaving' (click)="onLogin()">Login</button>
  
  <button type="submit" class="btn btn-primary btn-sm" *ngIf="loginExpireSeconds > 0" [ladda]='isSaving' (click)="manterSessao()">Manter a sessão</button>
  <button type="button" class="btn btn-default btn-sm" (click)="logout()">Cancelar a sessão</button>
</div>